"use client";

import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import clsx from "clsx";
import { CommentFormSection } from "@/components/Comment/components/form/CommentFormSection.component";
import { CommentsList } from "@/components/Comment/components/list/CommentsList.component";
import { CommentsGuidelines } from "@/components/Comment/components/prompts/CommentGuidelines.component";
import { useComments } from "@/components/Comment/context/comments.context";
import { useCommentsActions } from "@/components/Comment/hooks/use-comment-actions.hook";
import { SolidXMarkIcon } from "@/components/Icons/components/HeroIcons/SolidXmarkIcon.component";
import { Translation } from "@/components/Translation/Translation.component";
export function CommentsModal() {
  const $ = _c(23);
  const {
    state: t0
  } = useComments();
  const {
    isModalOpen,
    totalComments
  } = t0;
  const {
    closeModal
  } = useCommentsActions();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = clsx("flex h-full w-full flex-col bg-silent shadow-xl", "data-closed:translate-x-full", "data-enter:duration-300 data-enter:ease-out", "data-leave:duration-200 data-leave:ease-in");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Deltag i samtalen (${totalComments})`;
  const t3 = `Nehmen Sie an der Diskussion teil (${totalComments})`;
  const t4 = `Join the conversation (${totalComments})`;
  const t5 = `Bli med i samtalen (${totalComments})`;
  const t6 = `Delta i samtalet (${totalComments})`;
  let t7;
  if ($[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = <span className="font-theme-bold text-nero uppercase"><Translation da={t2} de={t3} en={t4} no={t5} sv={t6} /></span>;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SolidXMarkIcon className="size-3 text-dim" />;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== closeModal) {
    t9 = <button aria-label="Close comments" data-testid="comment-close-modal-btn" onClick={closeModal} type="button">{t8}</button>;
    $[8] = closeModal;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t9) {
    t10 = <DialogTitle className="flex items-center justify-between">{t7}{t9}</DialogTitle>;
    $[10] = t7;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <CommentsGuidelines />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10) {
    t12 = <div className="shrink-0 border-smoke border-b px-4 py-3">{t10}{t11}</div>;
    $[14] = t10;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex-1 overflow-y-auto p-4"><div className="mb-6"><CommentFormSection /></div><CommentsList /></div>;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t12) {
    t14 = <div className="fixed inset-0 flex justify-end"><DialogPanel className={t1} transition={true}>{t12}{t13}</DialogPanel></div>;
    $[17] = t12;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== closeModal || $[20] !== isModalOpen || $[21] !== t14) {
    t15 = <Dialog className="relative z-50 md:hidden" onClose={closeModal} open={isModalOpen}>{t14}</Dialog>;
    $[19] = closeModal;
    $[20] = isModalOpen;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}